const pageSizes = [ 10, 30, 50, 100];

export default pageSizes;